module.exports = __webpack_public_path__ + "static/media/moby_dick.bbf92d86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/snap/moby_dick.png
// module id = 39
// module chunks = 0